module.exports = __webpack_public_path__ + "img/antes_despues_249.e3ba4c9d.png";